import script from "./TextCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TextCardModal.vue?vue&type=script&setup=true&lang=js"

import "./TextCardModal.vue?vue&type=style&index=0&id=51623e3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51623e3a"]])

export default __exports__